// Auto-generated by bootstrap/scripts/build-info.ts. Do not edit.
export const BUILD_INFO = {
  branch: "feature/guest-accounts",
  sha: "1445da94e073dcd77b3db98d33cb7d9edc8978cb",
  sha_short: "1445da94",
  built_at: "2026-10-24T00:23:20.185Z",
  commit_time: "2026-10-24T09:23:16+09:00",
} as const;

export type BuildInfo = typeof BUILD_INFO;
